import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface DialogData {
  colorId: string,
  selectedFile,
  imageUrl
}
@Component({
  selector: 'app-upload-color-image',
  templateUrl: './upload-color-image.component.html',
  styleUrls: ['./upload-color-image.component.css']
})
export class UploadColorImageComponent implements OnInit {

  private result: any = {};
  public selectedFile = [];
  public imageLocation = 'front';
  public imageUrl = [];

  constructor(
    public dialogRef: MatDialogRef<UploadColorImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  onProductFileChanged(event) {
    if (this.data.selectedFile[this.data.colorId]) {
      Object.assign(this.data.selectedFile[this.data.colorId], {
        [this.imageLocation]: {
          selectedFile: event.target.files[0]
        }
      });
    }
    else {
      this.data.selectedFile[this.data.colorId] = {
        [this.imageLocation]: {
          selectedFile: event.target.files[0]
        }
      }
    }

    var render = new FileReader();
    render.onload = (event: any) => {
      if (this.data.imageUrl[this.data.colorId]) {
        Object.assign(this.data.imageUrl[this.data.colorId], {
          [this.imageLocation]: {
            imageUrl: event.target.result
          }
        });
      }
      else {
        this.data.imageUrl[this.data.colorId] = {
          [this.imageLocation]: {
            imageUrl: event.target.result
          }
        }
      }
    }
    render.readAsDataURL(event.target.files[0]);

  }

  activeLocation(location) {
    this.imageLocation = location;
  }

  saveProductImage() {   
    this.dialogRef.close(this.result);
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/upload-color-image/upload-color-image.component.ts